// extracted by mini-css-extract-plugin
module.exports = {"code":"SafeAsPathLink_code__DUY8H"};